"use client";

import { useEffect } from "react";

import { disableDatadog, enableDatadog } from "@/lib/consent/datadog";
import { useConsent } from "@/lib/consent/store";

/**
 * Starts Datadog RUM + Logs only once the visitor has accepted analytics
 * (and the deployment allows it), and stops it again when consent is
 * withdrawn or a Global Privacy Control signal is present.
 */
export function DatadogInit() {
  const { ready, analytics } = useConsent();

  useEffect(() => {
    if (!ready) return;

    if (analytics) {
      void enableDatadog();
    } else {
      disableDatadog();
    }
  }, [ready, analytics]);

  return null;
}
